import { render, staticRenderFns } from "./EventReminder5.vue?vue&type=template&id=d1d1c646&scoped=true&"
import script from "./EventReminder5.vue?vue&type=script&lang=js&"
export * from "./EventReminder5.vue?vue&type=script&lang=js&"
import style0 from "./EventReminder5.vue?vue&type=style&index=0&id=d1d1c646&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d1c646",
  null
  
)

export default component.exports